import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-diceIcons-D20',
    templateUrl: './D20.svg',
    styleUrls: ['./diceIcons-D20.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiceIconsD20Component { }
